import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { TypeUtils } from "abweb/utils/TypeUtils";

/**
 * Class used by LayerGroup to store individual layer state. Best to let the LayerGroup construct and track these.
 */
export class Layer {
  constructor(layerGroupId, layerNode, id) {
    _defineProperty(this, "layerGroupId", void 0);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "layerNode", void 0);
    this.id = id || TypeUtils.generateUniqueId("ab-layer");
    this.layerNode = layerNode;
    this.layerGroupId = layerGroupId;
  }
}
//# sourceMappingURL=Layer.js.map
